'use strict';

/* globals config, $, app, bootbox, socket */

require([
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	'translator',
	'benchpress',
], function (Vue, translator, Benchpress) {
	var internals = {};

	Vue.component('video-note', {
		props: ['note', 'saveNote'],
		data: function () {
			return {
				hasFile: typeof this.note.content.videoId !== 'undefined',
			};
		},
		mounted: function () {
			internals.note = this.note;

			if (!this.note.content) {
				this.note.content = {
					thumbnailUrl: '',
					videoId: '',
				};
			}
		},
		methods: {
			showVideo: function () {
				internals.showVideo(this.note.content.videoId);
			},
			onUploadSuccess: function (uploads) {
				var _this = this;
				var videoUrl = (uploads.response.images[0] || {}).url;

				var getVideoId = /^video:([0-9]+)$/g;
				var videoId = parseInt(getVideoId.exec(videoUrl)[1], 10);
				internals.getVideoData(videoId, function (videoData) {
					_this.hasFile = true;

					_this.saveFilePermissions(videoData.url);
					_this.saveFilePermissions(videoData.thumbnailUrl);

					_this.saveFile({
						thumbnailUrl: videoData.thumbnailUrl,
						videoId,
					});
				});
			},
			saveFile: function (file) {
				this.note.content.thumbnailUrl = file.thumbnailUrl;
				this.note.content.videoId = file.videoId;

				this.saveNote();
			},
		},
		template: '<div>' +
			'<div class="note-video-player" v-if="hasFile" v-on:click="showVideo()"><i class="fa fa-play-circle" aria-hidden="true"></i><img :src="note.content.thumbnailUrl" style="width: 100%" alt="image" /></div>' +
			'<upload-component :has-file="hasFile" :note="note" :on-upload-success="onUploadSuccess" :save-file="saveFile"></upload-component>' +
			'</div>',
	});

	internals.getVideoData = function (videoId, callback) {
		socket.emit('plugins.videoSockets.getVideo', videoId, function (err, video) {
			if (err) {
				return app.alertError(err.message);
			}

			callback(video);
		});
	};

	internals.showVideo = function (videoId) {
		Benchpress.parse('board/note-video-modal', { videoId }, function (html) {
			bootbox.dialog({
				title: '[[ideas-board:note-video-player]]',
				message: html,
				size: 'large',
				buttons: {
					cancel: {
						label: '[[modules:bootbox.cancel]]',
						className: 'btn-link',
					},
				},
			});

			$('.custom-video').customVideo();
		});
	};
});

